<script>

import { RecycleScroller } from 'vue-virtual-scroller';
import NoResults from './no-results';

export default {
    name: 'workflow-grid',
    props: ['workflows', 'loading'],
    data() {
        return {
            nextPageToken: undefined,
        };
    },
    methods: {
    },
    computed: {
        anyWorkflows() {
            return this.workflows && this.workflows.length > 0;
        },
    },
    components: {
        RecycleScroller,
        'no-results': NoResults,
    },
};
</script>

<template>
    <section class="workflow-grid" :class="{ loading }">
        <div class="row-header">
            <div class="col col-id">{{ $t("dj-流程") }} ID</div>
            <div class="col col-link">Run ID</div>
            <div class="col col-name">{{ $t("dj-名称") }}</div>
            <div class="col col-status">{{ $t("dj-状态") }}</div>
            <div class="col col-start">{{ $t("dj-开始时间") }}</div>
            <div class="col col-end">{{ $t("dj-结束时间") }}</div>
        </div>
        <div class="spacer" />
        <no-results :results="workflows" v-if="!loading" />
        <RecycleScroller
            key-field="uniqueId"
            :items="workflows"
            :item-size="56"
            emit-update
            ref="workflowGrid"
            data-cy="workflow-list"
            class="workflow-grid results"
            v-if="anyWorkflows"
            v-slot="{ item, index }"
        >
            <div class="row" :class="{ odd: index % 2 === 1 }">
                <div class="col col-id">{{ item.workflowId }}</div>
                <div class="col col-link">
                    <router-link
                        :to="{
                            name: 'workflow/summary',
                            params: {
                                clusterName: item.clusterName,
                                domain: 'athena',
                                runId: item.runId,
                                workflowId: item.workflowId,
                            },
                        }"
                        data-cy="workflow-link"
                    >{{ item.runId }}
                    </router-link>
                </div>
                <div class="col col-name">{{ item.workflowName }}</div>
                <div class="col col-status" :class="item.status">{{ item.status }}</div>
                <div class="col col-start">{{ item.startTime }}</div>
                <div class="col col-end">{{ item.endTime }}</div>
            </div>
        </RecycleScroller>
    </section>
</template>

<style lang="stylus">
@require "../styles/definitions.styl";

paged-grid();

.workflow-grid {
  height: calc(100vh - 203px);

  &.loading.has-results::after {
    content: none;
  }

  .row-header {
    display: flex;
    position: relative;
    padding: 0 1rem;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;

    color: rgb(0, 0, 0);
    font-weight: 500;
    text-transform: uppercase;

    box-shadow: 0px 2px 2px rgba(0,0,0,0.2);
    width: calc(100% - 10px);
  }

  .row {
    height: 56px;
    padding: 0 1rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    line-height: 1.2rem;

    &.odd {
      background-color: uber-white-10;
    }

    .col.col-status {
      text-transform: capitalize;
    }
  }


  .col {
    align-self: center;
    flex-basis: auto;
    padding: 0.5rem;

    &.col-id {
      flex: 1;
      word-break: break-all;
    }

    &.col-link {
      width: 300px;
    }

    &.col-name {
      flex: 1;
      word-break: break-all;
    }

    &.col-status {
      width: 150px;

      &.completed {
        color: uber-green;
      }

      &.failed {
        color: uber-orange;
      }

      &.running {
        color: uber-blue-120;
      }
    }

    &.col-start {
      width: 170px;
    }

    &.col-end {
      width: 170px;
    }
  }
}
</style>
